import styled from "react-emotion";

const SectionName = styled("h2")`
  margin: 0px 0px 5px 0px;
  font-size: 16px;
  font-weight: 700;
`;

export default SectionName;


// WEBPACK FOOTER //
// ./src/elements/SectionName.tsx